import { useInfiniteQuery, useQuery } from 'react-query'
import { type ClientDomain } from '../../../../types/domain/client-domain'

import { type FiltersDomain } from '../../../../types/domain/filters-domain'
import type PaginationDomain from '../../../../types/domain/pagination-domain'
import { getValidFilters } from '../../../../utils/filters'
import { getQueryStrinfied } from '../../../../utils/query'
import { api } from '../../../api'

export const fetchClients = async (filters: FiltersDomain) => {
  const query = getQueryStrinfied(getValidFilters(filters))

  const { data } = await api.get<PaginationDomain<ClientDomain>>(`/clients?${query}`)
  return data
}

export const useClientsQuery = (filters: FiltersDomain) => {
  return useQuery(
    ['clients', filters],
    () => fetchClients(filters),
    { staleTime: 1000 * 60 * 60 * 1, keepPreviousData: true } // 1 hour
  )
}

export const useInfiniteClientesQuery = (filters: FiltersDomain) => {
  return useInfiniteQuery(
    ['clients', filters],
    ({ pageParam = 1 }) => fetchClients({ ...filters, page: pageParam }),
    {
      staleTime: 1000 * 60 * 60 * 1, // 1 hour
      getNextPageParam ({ meta }) {
        return meta.hasNextPage ? meta.page + 1 : undefined
      },
    }
  )
}
